import { useCallback } from 'react';
import { useKeysDown } from 'shared/hooks/use-keys-down';
import { useModifierKeysDown } from 'shared/hooks/use-modifier-keys-down';
import { targetIsInput } from 'shared/utils/target-is-input';

// Browsers reserve ⌘/Ctrl + key for themselves (⌘K focuses the URL bar), so the web build binds the bare key instead.
export const usePlatformShortcut = (key: string, callback: () => void) => {
  const onDesktopKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (!window.electron || targetIsInput(e.target)) {
        return;
      }
      e.preventDefault();
      callback();
    },
    [callback],
  );

  const onBrowserKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (window.electron || targetIsInput(e.target)) {
        return;
      }
      // Without this the key types itself into the input that a freshly-opened dialog autofocuses.
      e.preventDefault();
      callback();
    },
    [callback],
  );

  useModifierKeysDown(key, onDesktopKeyDown);
  useKeysDown([key], onBrowserKeyDown);
};
